module.exports = __webpack_public_path__ + "static/img/classroom_img04.e6995d63.png";